// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-view {
  background-color: white;
  height: 100vh;
  width: 100%;
  display: inline-block;
  font-family: mreaves-regular;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view {
    display: flex;
    flex-flow: column;
  }
}
.dashboard-view section {
  display: inline-block;
}
.dashboard-view .left-section {
  width: 120px;
  background-color: #e3b5bb;
  height: 100vh;
  overflow: auto;
  text-align: center;
  float: left;
  position: relative;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .left-section {
    overflow: visible;
    overflow: initial;
    width: auto;
    display: flex;
    height: auto;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .left-section .left-section-buttons {
    display: flex;
    width: 75%;
    flex-direction: column;
  }
}
.dashboard-view .left-section .logout-button {
  color: white;
  position: absolute;
  bottom: 15px;
  margin: auto;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: -40px;
  width: max-content;
}
.dashboard-view .left-section .logout-button img {
  width: 50px !important;
  height: 50px;
  background: #ffffff;
  border-radius: 50%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .left-section .logout-button {
    width: 50%;
  }
}
.dashboard-view .left-section .dashboard-link {
  display: block;
  color: white;
  padding: 15px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 20px;
  line-height: 40px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .left-section .dashboard-link {
    width: 50%;
  }
}
.dashboard-view .left-section .dashboard-link:hover {
  background-color: #9d9d9d;
  color: white;
  transition: all 0.5s ease;
  text-decoration: none;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);
}
.dashboard-view .left-section .dashboard-link:active {
  background-color: white;
  color: #000;
  transition: all 0.5s ease;
  text-decoration: none;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);
}
.dashboard-view .left-section .dashboard-link .dashboard-logo {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: block;
  margin: auto;
}
.dashboard-view .left-section .dashboard-bottom-link {
  position: absolute;
  bottom: 45px;
  margin: auto;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 5px;
}
.dashboard-view .left-section .dashboard-bottom-link .letter {
  color: white;
  background: transparent;
  border: 1px solid white;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  margin: auto;
  width: 50px;
  border-radius: 50%;
  display: block;
  margin-bottom: 10px;
}
.dashboard-view .left-section .dashboard-bottom-link span {
  display: block;
  width: 100%;
  color: white;
  line-height: 18px;
}
.dashboard-view .left-section .dashboard-bottom-link span.name {
  font-weight: bold;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .left-section .dashboard-bottom-link {
    position: relative;
    left: auto;
    left: initial;
    transform: none;
    transform: initial;
  }
}
.dashboard-view .left-section .dashboard-bottom-link:hover {
  text-decoration: none;
}
.dashboard-view .center-section {
  width: calc(100% - 620px);
  min-height: 100%;
  padding: 15px;
  height: 100%;
  overflow: scroll;
  overflow-y: scroll;
  max-height: 100%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .center-section {
    width: auto;
    min-height: 0;
    min-height: initial;
  }
}
.dashboard-view .center-section .menu-card {
  height: 250px;
  min-width: 300px;
  width: calc(50% - 20px);
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin: 10px;
  border-radius: 20px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .center-section .menu-card {
    margin: 0;
    min-width: 0;
    min-width: initial;
    width: 100%;
  }
}
.dashboard-view .center-section .menu-card:hover {
  text-decoration: none;
}
.dashboard-view .center-section .menu-card .card-left {
  float: left;
  min-height: 100%;
  width: 30%;
  display: inline-block;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  text-align: center;
  position: relative;
}
.dashboard-view .center-section .menu-card .card-left.orders-card-left {
  background-color: #000;
}
.dashboard-view .center-section .menu-card .card-left.orders-card-left .card-icon {
  color: #000;
}
.dashboard-view .center-section .menu-card .card-left.customer-card-left {
  background-color: black;
}
.dashboard-view .center-section .menu-card .card-left.customer-card-left .card-icon {
  color: black;
}
.dashboard-view .center-section .menu-card .card-left.user-card-left {
  background-color: black;
}
.dashboard-view .center-section .menu-card .card-left.user-card-left .card-icon {
  color: black;
}
.dashboard-view .center-section .menu-card .card-left.custom-request-card-left {
  background-color: #6b4773;
}
.dashboard-view .center-section .menu-card .card-left.report-card-left {
  background-color: #de7d90;
}
.dashboard-view .center-section .menu-card .card-left .card-left-section {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dashboard-view .center-section .menu-card .card-left .card-left-section .card-icon {
  background-color: white;
  display: block;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  text-align: center;
  font-size: 40px;
  margin: auto;
  margin-bottom: 10px;
}
.dashboard-view .center-section .menu-card .card-left .card-left-section .card-icon img {
  border-radius: 50%;
  height: 100%;
  width: 100%;
}
.dashboard-view .center-section .menu-card .card-left .card-left-section .card-name {
  color: white;
  font-weight: bold;
  display: block;
  text-transform: uppercase;
  font-size: 20px;
}
.dashboard-view .center-section .menu-card .card-right {
  float: right;
  min-height: 100%;
  width: 70%;
  display: inline-block;
  background-color: white;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  position: relative;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  width: 100%;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div {
  padding: 15px;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-name {
  display: inline-block;
  font-size: 20px;
  width: 60%;
  text-align: right;
  font-weight: bold;
  text-transform: uppercase;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon {
  display: inline-block;
  color: white;
  text-align: center;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  line-height: 75px;
  font-size: 25px;
  margin-left: 15px;
  transition: background-color 0.5s ease;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon:hover {
  background-color: #8f8f8f !important;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon.order-icon {
  background-color: #000;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon.customer-icon {
  background-color: #000;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon.user-icon {
  background-color: #000;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon.custom-request-icon {
  background-color: #6b4773;
}
.dashboard-view .center-section .menu-card .card-right .card-right-section .card-link-div .card-link-icon.report-icon {
  background-color: #de7d90;
}
.dashboard-view .right-section {
  background-color: #faf3f4;
  width: 500px;
  height: 100vh;
  float: right;
  position: relative;
  padding: 15px 25px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .dashboard-view .right-section {
    width: auto;
  }
}
.dashboard-view .right-section .add-task-button {
  cursor: pointer;
}
.dashboard-view .right-section .activity-old-value {
  color: #ff6b00;
}
.dashboard-view .right-section .activity-new-value {
  color: #ff9800;
}
.dashboard-view .right-section .search-section .search-input {
  background-color: white;
  border: 1px solid white;
  height: 39px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  padding: 0 15px;
}
.dashboard-view .right-section .search-section .search-input:focus {
  border-color: white !important;
  outline: none;
}
.dashboard-view .right-section .search-section .search-input-group-text {
  background-color: white;
  border: 1px solid white;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  height: 39px;
  font-size: 15px;
}
.dashboard-view .right-section .tab-section {
  margin-top: 35px;
}
.dashboard-view .right-section .tab-section .tab-activity-assigned .infinite-scroll-parent-div,
.dashboard-view .right-section .tab-section .tab-activity-unassigned .infinite-scroll-parent-div,
.dashboard-view .right-section .tab-section .tab-activity-history .infinite-scroll-parent-div {
  height: calc(100vh - 190px);
  overflow: auto;
}
.dashboard-view .right-section .tab-section .tab-my-tasks .infinite-scroll-parent-div {
  height: 80vh;
  overflow: auto;
}
.dashboard-view .right-section .tab-section .my-task-items-list .task-card {
  color: black;
  display: block;
  margin-bottom: 20px;
  padding: 0px 15px;
  padding: 20px 20px;
  border-radius: 15px;
  padding-bottom: 0px;
  text-decoration: none;
  background: white;
  position: relative;
  margin-right: 10px;
  overflow: hidden;
}
.dashboard-view .right-section .tab-section .my-task-items-list .task-card .card-body a {
  color: #000;
  text-decoration: none;
}
.dashboard-view .right-section .tab-section .my-task-items-list .task-card .card-body a:hover {
  text-decoration: underline;
}
.dashboard-view .right-section .tab-section .my-task-items-list .task-card .card-title {
  font-weight: bold;
}
.dashboard-view .right-section .tab-section .my-task-items-list .task-card .customer-name {
  font-size: 15px;
  color: #000;
  padding-bottom: 5px;
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 5px;
}
.dashboard-view .right-section .tab-section .my-task-items-list .btn-done {
  background-color: #8ba6eb;
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 10px;
  color: white;
  width: calc(50% - 10px);
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section {
  width: calc(100% + 40px);
  position: relative;
  margin-left: -20px;
  /* one item */
  /* two items */
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .confirm-text {
  width: 90%;
  margin: auto;
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn {
  width: 50%;
  background-color: black;
  padding: 5px 15px;
  color: white;
  border-radius: 0px;
  text-transform: uppercase;
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn.complete-btn {
  border-right: 1px solid white;
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn:hover {
  background-color: #9d9d9d;
  transition: all 0.5s ease;
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn:first-child:nth-last-child(1) {
  /* -or- li:only-child { */
  width: 100%;
}
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn:first-child:nth-last-child(2),
.dashboard-view .right-section .tab-section .my-task-items-list .button-section .btn:first-child:nth-last-child(2) ~ .btn {
  width: 50%;
}
.dashboard-view .right-section .nav-tabs {
  border: none;
}
.dashboard-view .right-section .nav-tabs.submenu .nav-link {
  font-size: 17px;
  margin-right: 10px;
}
.dashboard-view .right-section .nav-tabs .nav-link {
  position: relative;
  background-color: transparent;
  border: none;
  padding: 0px;
  margin-right: 30px;
  font-size: 25px;
  color: #9d9d9d;
  position: relative;
  font-weight: bold;
}
.dashboard-view .right-section .nav-tabs .nav-link.active {
  color: black;
}
.dashboard-view .right-section .nav-tabs .nav-link.active::before {
  content: "";
  position: absolute;
  background-color: #cba5ac;
  width: 30px;
  height: 5px;
  top: -5px;
  left: 0;
  border-radius: 15px;
}
.dashboard-view .right-section .nav-tabs .nav-link.active .activity-badge-section {
  border: 2px solid #524c58;
  color: #524c58;
}
.dashboard-view .right-section .nav-tabs .nav-link .notification-count {
  display: inline-block;
  color: white;
  width: 24px;
  line-height: 24px;
  font-size: 15px;
  text-align: center;
  border-radius: 50%;
  background-color: #cba5ac;
}
.dashboard-view .right-section .nav-tabs .nav-link .badge-section {
  position: absolute;
  background: transparent;
  border: 2px solid #e3b5bb;
  color: black;
  font-size: 15px;
  line-height: 12px;
  padding: 5px 6px;
  margin-left: 5px;
  border-radius: 5px;
}
.dashboard-view .right-section .nav-tabs .nav-link .activity-badge-section {
  position: relative;
  top: -10px;
  right: 0px;
  border: 2px solid #9d9d9d;
  /* height: 20px; */
  font-size: 12px;
  line-height: 12px;
  padding: 2px 6px;
  color: #9d9d9d;
  border-radius: 5px;
}
.dashboard-view .right-section .accordions .accordion {
  overflow: auto;
}
.dashboard-view .right-section .accordions .accordion .accordion-link {
  color: black;
  font-size: 15px;
}
.dashboard-view .right-section .accordions .accordion .accordion-link:hover {
  text-decoration: none;
}
.dashboard-view .right-section .accordions .accordion .accordion-data {
  display: none;
}
.dashboard-view .right-section .accordions .accordion .accordion-data:first-child {
  margin-top: 0px;
}
.dashboard-view .right-section .accordions .accordion .accordion-data.show {
  display: block;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data {
  color: black;
  display: block;
  margin-bottom: 20px;
  padding: 0px 15px;
  padding: 20px 20px;
  border-radius: 15px;
  padding-bottom: 0px;
  text-decoration: none;
  background: white;
  position: relative;
  margin-right: 10px;
  overflow: hidden;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data:hover {
  text-decoration: none;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .card-title a {
  color: #000;
  text-decoration: none;
  font-weight: bold;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .card-title a:hover {
  text-decoration: underline;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-data a {
  color: #000;
  text-decoration: none;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-data a:hover {
  text-decoration: underline;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-no {
  font-weight: bold;
  display: block;
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-date {
  position: absolute;
  background-color: #ecedf2;
  font-size: 13px;
  right: 0px;
  top: 0px;
  padding: 3px 10px;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-data {
  display: block;
  line-height: 20px;
  margin-bottom: 10px;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-data.customer-name {
  padding-bottom: 5px;
  border-bottom: 1px solid #d2d2d2;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .order-time {
  color: #d2d2d2;
  text-align: right;
  margin-bottom: 0;
  font-size: 13px;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section {
  width: calc(100% + 40px);
  position: relative;
  margin-left: -20px;
  /* one item */
  /* two items */
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn {
  width: 50%;
  background-color: black;
  padding: 5px 15px;
  color: white;
  border-radius: 0px;
  text-transform: uppercase;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn.complete-btn {
  border-right: 1px solid white;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn:hover {
  background-color: #9d9d9d;
  transition: all 0.5s ease;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn .border-right {
  border-right: 1px solid white;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn:first-child:nth-last-child(1) {
  /* -or- li:only-child { */
  width: 100%;
}
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn:first-child:nth-last-child(2),
.dashboard-view .right-section .accordions .accordion .accordion-data .accordion-order-data .button-section .btn:first-child:nth-last-child(2) ~ .btn {
  width: 50%;
}

.except-left-section {
  width: calc(100% - 120px);
  min-height: 100%;
  height: 100vh;
  overflow: auto;
  padding: 15px;
  background: #f3f6fd;
}
.except-left-section .back-to-table a {
  color: black;
  font-size: 15px;
}
.except-left-section .back-to-table a .back-icon {
  background-color: #8ba6eb;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: inline-block;
  line-height: 34px;
  text-align: center;
  color: white;
  margin-right: 10px;
}
.except-left-section .back-to-table a:hover {
  text-decoration: none;
}
.except-left-section .back-to-table a .add-icon {
  float: right;
  background-color: #8ba6eb;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: inline-block;
  line-height: 34px;
  text-align: center;
  color: white;
  margin-right: 10px;
}
.except-left-section .white-box {
  background-color: white;
  padding: 15px;
  margin-bottom: 15px;
}
.except-left-section .order_detail .data-card {
  background-color: white;
  border: 1px solid #f8f8f8;
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
  margin-bottom: 15px;
}
.except-left-section .order_detail .data-card .information-heading {
  border-top-right-radius: 15px;
  color: white;
  text-align: left;
  padding: 7px 15px;
  font-size: 25px;
  line-height: 25px;
}
.except-left-section .order_detail .data-card .information-heading.customer-information {
  background-color: #74cdd2;
}
.except-left-section .order_detail .data-card .information-heading.payment-information {
  background-color: #f1764a;
}
.except-left-section .order_detail .data-card .information-heading.product-information {
  background-color: #f2d39a;
}
.except-left-section .order_detail .data-card .information-heading.manufacturing-information {
  background-color: #acd6ca;
}
.except-left-section .order_detail .data-card .information-heading.discussion-information {
  background-color: #ace9fb;
}
.except-left-section .order_detail .data-card .information-heading.history-information {
  background-color: #7c759f;
}
.except-left-section .order_detail .data-card .information-details .details {
  padding: 15px !important;
}
.except-left-section .order_detail .data-card .information-details .details .shipping_informaiton {
  margin-bottom: 15px;
}
.except-left-section .order_detail .data-card .information-details .details .shipping_informaiton h3 {
  font-weight: bold;
}
.except-left-section .order_detail .data-card .information-details .details .billing_informaiton {
  margin-bottom: 15px;
}
.except-left-section .order_detail .data-card .information-details .details .billing_informaiton h3 {
  font-weight: bold;
}

.Completed {
  color: green;
}

.Assigned {
  color: orange;
}

.due-date-warning {
  color: red;
}

.confirmationLinks {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}

.add-task-button {
  cursor: pointer;
}

a.add_link {
  cursor: pointer;
}

.form-control.box-bg {
  height: 32px;
}

.content-table-stock-number {
  max-height: 40vh;
  overflow-y: scroll;
}

.btn-novitadimonds {
  height: 30px !important;
  border-radius: 6px !important;
  text-align: center !important;
  background-color: #dfa4a3 !important;
  font-size: 15px !important;
  font-family: "mreaves-regular";
  border-color: #dfa4a3 !important;
  color: #fff !important;
  min-width: max-content;
  padding: 0px 5px !important;
}

.btn-novitadimonds:hover {
  color: #fff !important;
  background-color: #dfa4a3 !important;
  border-color: #dfa4a3 !important;
}

.hide {
  display: none;
}

.form-select.is-valid,
.was-validated .form-select:valid {
  border-color: #e3b5bb !important;
}

.form-select:focus {
  box-shadow: none !important;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #e3b5bb !important;
}

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #000 !important;
}

.form-check-input.is-valid:checked,
.was-validated .form-check-input:valid:checked {
  background-color: #e3b5bb !important;
}

.form-check-input.is-valid,
.was-validated .form-check-input:valid {
  border-color: #e3b5bb !important;
}

.has-success .fv-plugins-icon {
  color: red;
}

.icon-btn-novitadiamond {
  height: 20px;
  background: #e3b5bb;
  border-radius: 50%;
  padding: 6px;
  color: white;
}

.grid-padding-0 {
  display: grid;
  padding: 0;
}

.line-height-initial {
  line-height: normal;
  line-height: initial;
}

.position-sticky-bottom {
  position: sticky;
  bottom: 10px;
}

.float-right {
  float: right;
}

.overflow-hidden {
  overflow: hidden;
}

.not-margin {
  margin: 0px !important;
}

.input-group-pink .form-control {
  border-color: #e3b5bb !important;
}
.input-group-pink .input-group-text {
  color: white;
  background: #e3b5bb;
  border-color: #e3b5bb;
}

.card-sale-commissions {
  overflow-y: scroll;
  max-height: 84vh !important;
}
.card-sale-commissions .table-hover > tbody > tr > td.error {
  background: #d66;
  color: white !important;
}
.card-sale-commissions .table-hover > tbody > tr > td.success {
  background: #35b97d;
  color: white !important;
}

.btn-icon-pink {
  height: 30px !important;
  width: 30px !important;
  border-radius: 50% !important;
  font-size: 16px !important;
  line-height: 15px !important;
  border: 1px solid #e3b5bb !important;
  background: #e3b5bb !important;
  margin-left: 15px !important;
  text-align: center !important;
  color: white !important;
  padding: 0px !important;
  display: inline-block !important;
}

.order-number-small {
  font-size: 14px !important;
}

.disabled-btn {
  cursor: no-drop !important;
  opacity: 0.5 !important;
}

.hidden-elements {
  overflow: hidden;
  text-overflow: ellipsis;
}

.qcc-title-inprocess {
  padding: 0px 5px;
  border-radius: 5px;
}

.tooltip-extra-info {
  color: #c9c9c9;
  font-size: 12px;
  text-decoration: underline;
}

.table-container {
  width: 100%;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: auto;
}
.table-container table {
  width: 100%;
  border-collapse: collapse;
}
.table-container th,
.table-container td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.table-container thead {
  background-color: #000;
  color: #fff;
  position: sticky;
  top: 0;
}

.react-datepicker-popper {
  z-index: 999999;
}

.loading-process #LoadingLayer_component {
  position: fixed;
  top: 0px;
  left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/css/dashboard.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,4BAAA;AACF;AACE;EAPF;IAQI,aAAA;IACA,iBAAA;EAEF;AACF;AAAE;EACE,qBAAA;AAEJ;AACE;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AACI;EATF;IAUI,iBAAA;IAAA,iBAAA;IACA,WAAA;IACA,aAAA;IACA,YAAA;EAEJ;AACF;AACM;EADF;IAEI,aAAA;IACA,UAAA;IACA,sBAAA;EAEN;AACF;AACI;EAEE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;AAAN;AAEM;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAIM;EAnBF;IAoBI,UAAA;EADN;AACF;AAII;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAFN;AAIM;EATF;IAUI,UAAA;EADN;AACF;AAGM;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,6CAAA;AADR;AAIM;EACE,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,6CAAA;AAFR;AAKM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAHR;AAOI;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;AALN;AAOM;EACE,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AALR;AAQM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AANR;AAQQ;EACE,iBAAA;AANV;AAUM;EAjCF;IAkCI,kBAAA;IACA,UAAA;IAAA,aAAA;IACA,eAAA;IAAA,kBAAA;EAPN;AACF;AASM;EACE,qBAAA;AAPR;AAYE;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAYI;EATF;IAUI,WAAA;IACA,aAAA;IAAA,mBAAA;EATJ;AACF;AAWI;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AATN;AAWM;EAXF;IAYI,SAAA;IACA,YAAA;IAAA,kBAAA;IACA,WAAA;EARN;AACF;AAUM;EACE,qBAAA;AARR;AAWM;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;AATR;AAWQ;EACE,sBAAA;AATV;AAWU;EACE,WAAA;AATZ;AAaQ;EACE,uBAAA;AAXV;AAaU;EACE,YAAA;AAXZ;AAeQ;EACE,uBAAA;AAbV;AAeU;EACE,YAAA;AAbZ;AAiBQ;EACE,yBAAA;AAfV;AAkBQ;EACE,yBAAA;AAhBV;AAmBQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAjBV;AAmBU;EACE,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EAEA,mBAAA;AAlBZ;AAoBY;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAlBd;AAsBU;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AApBZ;AAyBM;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;AAvBR;AAyBQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;AAvBV;AAyBU;EACE,aAAA;AAvBZ;AAyBY;EACE,qBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAvBd;AA0BY;EACE,qBAAA;EAEA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AAzBd;AA2Bc;EACE,oCAAA;AAzBhB;AA4Bc;EACE,sBAAA;AA1BhB;AA6Bc;EACE,sBAAA;AA3BhB;AA8Bc;EACE,sBAAA;AA5BhB;AA+Bc;EACE,yBAAA;AA7BhB;AAgCc;EACE,yBAAA;AA9BhB;AAuCE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AArCJ;AAyCI;EAVF;IAWI,WAAA;EAtCJ;AACF;AAwCI;EACE,eAAA;AAtCN;AA6CI;EACE,cAAA;AA3CN;AA8CI;EACE,cAAA;AA5CN;AAgDM;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;AA9CR;AAgDQ;EACE,8BAAA;EACA,aAAA;AA9CV;AAkDM;EACE,uBAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;AAhDR;AAoDI;EACE,gBAAA;AAlDN;AA4DQ;;;EACE,2BAAA;EACA,cAAA;AAxDV;AA6DQ;EACE,YAAA;EACA,cAAA;AA3DV;AAqEQ;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAnEV;AAsEY;EACE,WAAA;EACA,qBAAA;AApEd;AAsEc;EACE,0BAAA;AApEhB;AAyEU;EACE,iBAAA;AAvEZ;AA0EU;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AAxEZ;AA4EQ;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AA1EV;AA6EQ;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EA4BA,aAAA;EAMA,cAAA;AA3GV;AA2EU;EACE,UAAA;EACA,YAAA;AAzEZ;AA4EU;EACE,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA1EZ;AA4EY;EACE,6BAAA;AA1Ed;AAgFY;EACE,yBAAA;EACA,yBAAA;AA9Ed;AAmFU;EACE,yBAAA;EACA,WAAA;AAjFZ;AAqFU;;EAEE,UAAA;AAnFZ;AA0GI;EAQE,YAAA;AA/GN;AAyGQ;EACE,eAAA;EACA,kBAAA;AAvGV;AA6GM;EACE,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AA3GR;AA6GQ;EACE,YAAA;AA3GV;AA6GU;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;AA3GZ;AA8GU;EACE,yBAAA;EACA,cAAA;AA5GZ;AAgHQ;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AA9GV;AAiHQ;EACE,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA/GV;AAkHQ;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAhHV;AAuHM;EACE,cAAA;AArHR;AAwHQ;EACE,YAAA;EACA,eAAA;AAtHV;AAwHU;EACE,qBAAA;AAtHZ;AA0HQ;EACE,aAAA;AAxHV;AA0HU;EACE,eAAA;AAxHZ;AA2HU;EACE,cAAA;AAzHZ;AA4HU;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA1HZ;AAoIY;EACE,qBAAA;AAlId;AAsIc;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;AApIhB;AAsIgB;EACE,0BAAA;AApIlB;AA0Ic;EACE,WAAA;EACA,qBAAA;AAxIhB;AA0IgB;EACE,0BAAA;AAxIlB;AA6IY;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA3Id;AA8IY;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;AA5Id;AA+IY;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;AA7Id;AA+Ic;EACE,mBAAA;EACA,gCAAA;AA7IhB;AAiJY;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AA/Id;AAkJY;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EA2BA,aAAA;EAMA,cAAA;AA/Kd;AAgJc;EACE,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA9IhB;AAgJgB;EACE,6BAAA;AA9IlB;AAoJgB;EACE,yBAAA;EACA,yBAAA;AAlJlB;AAqJgB;EACE,6BAAA;AAnJlB;AAwJc;EACE,yBAAA;EACA,WAAA;AAtJhB;AA0Jc;;EAEE,UAAA;AAxJhB;;AAkKA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA/JF;AAkKI;EACE,YAAA;EACA,eAAA;AAhKN;AAkKM;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAhKR;AAmKM;EACE,qBAAA;AAjKR;AAoKM;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAlKR;AAuKE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;AArKJ;AAyKI;EACE,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,mBAAA;AAvKN;AAyKM;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAvKR;AAyKQ;EACE,yBAAA;AAvKV;AA0KQ;EACE,yBAAA;AAxKV;AA2KQ;EACE,yBAAA;AAzKV;AA4KQ;EACE,yBAAA;AA1KV;AA6KQ;EACE,yBAAA;AA3KV;AA8KQ;EACE,yBAAA;AA5KV;AAiLQ;EACE,wBAAA;AA/KV;AAiLU;EACE,mBAAA;AA/KZ;AAiLY;EACE,iBAAA;AA/Kd;AAmLU;EACE,mBAAA;AAjLZ;AAmLY;EACE,iBAAA;AAjLd;;AA0LA;EACE,YAAA;AAvLF;;AA0LA;EACE,aAAA;AAvLF;;AA0LA;EACE,UAAA;AAvLF;;AA0LA;EACE,eAAA;EACA,WAAA;EACA,0BAAA;AAvLF;;AA0LA;EACE,eAAA;AAvLF;;AA0LA;EACE,eAAA;AAvLF;;AA0LA;EACE,YAAA;AAvLF;;AA0LA;EACE,gBAAA;EACA,kBAAA;AAvLF;;AA0LA;EACE,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;AAvLF;;AA0LA;EACE,sBAAA;EACA,oCAAA;EACA,gCAAA;AAvLF;;AA0LA;EACE,aAAA;AAvLF;;AA0LA;;EAEE,gCAAA;AAvLF;;AA0LA;EACE,2BAAA;AAvLF;;AA0LA;;EAEE,gCAAA;AAvLF;;AA0LA;;EAEE,sBAAA;AAvLF;;AA0LA;;EAEE,oCAAA;AAvLF;;AA0LA;;EAEE,gCAAA;AAvLF;;AA0LA;EACE,UAAA;AAvLF;;AA0LA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAvLF;;AA0LA;EACE,aAAA;EACA,UAAA;AAvLF;;AA0LA;EACE,mBAAA;EAAA,oBAAA;AAvLF;;AA0LA;EACE,gBAAA;EACA,YAAA;AAvLF;;AA0LA;EACE,YAAA;AAvLF;;AA0LA;EACE,gBAAA;AAvLF;;AA0LA;EACE,sBAAA;AAvLF;;AA2LE;EACE,gCAAA;AAxLJ;AA2LE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;AAzLJ;;AA6LA;EACE,kBAAA;EACA,2BAAA;AA1LF;AA4LE;EACE,gBAAA;EACA,uBAAA;AA1LJ;AA6LE;EACE,mBAAA;EACA,uBAAA;AA3LJ;;AA+LA;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;AA5LF;;AA+LA;EACE,0BAAA;AA5LF;;AA+LA;EACE,0BAAA;EACA,uBAAA;AA5LF;;AA+LA;EACE,gBAAA;EACA,uBAAA;AA5LF;;AA+LA;EACE,gBAAA;EACA,kBAAA;AA5LF;;AA+LA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AA5LF;;AA+LA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA5LF;AA8LE;EACE,WAAA;EACA,yBAAA;AA5LJ;AA+LE;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;AA7LJ;AAgME;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,MAAA;AA9LJ;;AAkMA;EACE,eAAA;AA/LF;;AAmME;EACE,eAAA;EACA,QAAA;EACA,SAAA;AAhMJ","sourcesContent":[".dashboard-view {\n  background-color: white;\n  height: 100vh;\n  width: 100%;\n  display: inline-block;\n  font-family: mreaves-regular;\n\n  @media all and (min-width: 0px) and (max-width: 600px) {\n    display: flex;\n    flex-flow: column;\n  }\n\n  section {\n    display: inline-block;\n  }\n\n  .left-section {\n    width: 120px;\n    background-color: #e3b5bb;\n    height: 100vh;\n    overflow: auto;\n    text-align: center;\n    float: left;\n    position: relative;\n\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      overflow: unset;\n      width: auto;\n      display: flex;\n      height: auto;\n    }\n\n    .left-section-buttons {\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        display: flex;\n        width: 75%;\n        flex-direction: column;\n      }\n    }\n\n    .logout-button {\n      // background: #71CFD1;\n      color: white;\n      position: absolute;\n      bottom: 15px;\n      margin: auto;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      bottom: -40px;\n      width: max-content;\n\n      img {\n        width: 50px !important;\n        height: 50px;\n        background: #ffffff;\n        border-radius: 50%;\n      }\n\n      // border-radius: 50%;\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        width: 50%;\n      }\n    }\n\n    .dashboard-link {\n      display: block;\n      color: white;\n      padding: 15px;\n      text-transform: uppercase;\n      text-decoration: none;\n      font-size: 20px;\n      line-height: 40px;\n\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        width: 50%;\n      }\n\n      &:hover {\n        background-color: #9d9d9d;\n        color: white;\n        transition: all 0.5s ease;\n        text-decoration: none;\n        border-top-left-radius: 15px;\n        border-bottom-left-radius: 15px;\n        box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);\n      }\n\n      &:active {\n        background-color: white;\n        color: #000;\n        transition: all 0.5s ease;\n        text-decoration: none;\n        border-top-left-radius: 15px;\n        border-bottom-left-radius: 15px;\n        box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);\n      }\n\n      .dashboard-logo {\n        border-radius: 50%;\n        width: 60px;\n        height: 60px;\n        display: block;\n        margin: auto;\n      }\n    }\n\n    .dashboard-bottom-link {\n      position: absolute;\n      bottom: 45px;\n      margin: auto;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding: 5px;\n\n      .letter {\n        color: white;\n        background: transparent;\n        border: 1px solid white;\n        height: 50px;\n        line-height: 50px;\n        font-weight: bold;\n        margin: auto;\n        width: 50px;\n        border-radius: 50%;\n        display: block;\n        margin-bottom: 10px;\n      }\n\n      span {\n        display: block;\n        width: 100%;\n        color: white;\n        line-height: 18px;\n\n        &.name {\n          font-weight: bold;\n        }\n      }\n\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        position: relative;\n        left: unset;\n        transform: unset;\n      }\n\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n\n  .center-section {\n    width: calc(100% - 620px);\n    min-height: 100%;\n    padding: 15px;\n    height: 100%;\n    overflow: scroll;\n    overflow-y: scroll;\n    max-height: 100%;\n\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      width: auto;\n      min-height: unset;\n    }\n\n    .menu-card {\n      height: 250px;\n      min-width: 300px;\n      width: calc(50% - 20px);\n      display: inline-block;\n      background: #ffffff;\n      box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);\n      border-radius: 10px;\n      margin: 10px;\n      border-radius: 20px;\n\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        margin: 0;\n        min-width: unset;\n        width: 100%;\n      }\n\n      &:hover {\n        text-decoration: none;\n      }\n\n      .card-left {\n        float: left;\n        min-height: 100%;\n        width: 30%;\n        display: inline-block;\n        border-top-left-radius: 20px;\n        border-bottom-left-radius: 20px;\n        text-align: center;\n        position: relative;\n\n        &.orders-card-left {\n          background-color: #000;\n\n          .card-icon {\n            color: #000;\n          }\n        }\n\n        &.customer-card-left {\n          background-color: black;\n\n          .card-icon {\n            color: black;\n          }\n        }\n\n        &.user-card-left {\n          background-color: black;\n\n          .card-icon {\n            color: black;\n          }\n        }\n\n        &.custom-request-card-left {\n          background-color: #6b4773;\n        }\n\n        &.report-card-left {\n          background-color: #de7d90;\n        }\n\n        .card-left-section {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n\n          .card-icon {\n            background-color: white;\n            display: block;\n            height: 70px;\n            width: 70px;\n            border-radius: 50%;\n            text-align: center;\n            font-size: 40px;\n            margin: auto;\n            // color: #000;\n            margin-bottom: 10px;\n\n            img {\n              border-radius: 50%;\n              height: 100%;\n              width: 100%;\n            }\n          }\n\n          .card-name {\n            color: white;\n            font-weight: bold;\n            display: block;\n            text-transform: uppercase;\n            font-size: 20px;\n          }\n        }\n      }\n\n      .card-right {\n        float: right;\n        min-height: 100%;\n        width: 70%;\n        display: inline-block;\n        background-color: white;\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px;\n        position: relative;\n\n        .card-right-section {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          display: block;\n          width: 100%;\n\n          .card-link-div {\n            padding: 15px;\n\n            .card-link-name {\n              display: inline-block;\n              font-size: 20px;\n              width: 60%;\n              text-align: right;\n              font-weight: bold;\n              text-transform: uppercase;\n            }\n\n            .card-link-icon {\n              display: inline-block;\n              // background-color: #8BA6EB;\n              color: white;\n              text-align: center;\n              height: 70px;\n              width: 70px;\n              border-radius: 50%;\n              line-height: 75px;\n              font-size: 25px;\n              margin-left: 15px;\n              transition: background-color 0.5s ease;\n\n              &:hover {\n                background-color: #8f8f8f !important;\n              }\n\n              &.order-icon {\n                background-color: #000;\n              }\n\n              &.customer-icon {\n                background-color: #000;\n              }\n\n              &.user-icon {\n                background-color: #000;\n              }\n\n              &.custom-request-icon {\n                background-color: #6b4773;\n              }\n\n              &.report-icon {\n                background-color: #de7d90;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .right-section {\n    background-color: #faf3f4;\n    width: 500px;\n    height: 100vh;\n    float: right;\n    position: relative;\n    padding: 15px 25px;\n\n    //overflow: auto;\n    //overflow: unset;\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      width: auto;\n    }\n\n    .add-task-button {\n      cursor: pointer;\n    }\n\n    .activity-field-value {\n      // font-weight: bold;\n    }\n\n    .activity-old-value {\n      color: #ff6b00;\n    }\n\n    .activity-new-value {\n      color: #ff9800;\n    }\n\n    .search-section {\n      .search-input {\n        background-color: white;\n        border: 1px solid white;\n        height: 39px;\n        border-top-left-radius: 6px;\n        border-bottom-left-radius: 6px;\n        padding: 0 15px;\n\n        &:focus {\n          border-color: white !important;\n          outline: none;\n        }\n      }\n\n      .search-input-group-text {\n        background-color: white;\n        border: 1px solid white;\n        border-top-right-radius: 6px;\n        border-bottom-right-radius: 6px;\n        height: 39px;\n        font-size: 15px;\n      }\n    }\n\n    .tab-section {\n      margin-top: 35px;\n\n      .tab-activity-assigned,\n      .tab-activity-unassigned,\n      .tab-activity-history {\n        .accordions {\n          //height: 80vh;\n          //overflow: auto;\n        }\n\n        .infinite-scroll-parent-div {\n          height: calc(100vh - 190px);\n          overflow: auto;\n        }\n      }\n\n      .tab-my-tasks {\n        .infinite-scroll-parent-div {\n          height: 80vh;\n          overflow: auto;\n        }\n      }\n\n      .my-task-items-list {\n        //display: flex;\n        //flex-direction: column-reverse;\n        //height: 90vh;\n        //position: relative;\n        //overflow: auto;\n        .task-card {\n          color: black;\n          display: block;\n          margin-bottom: 20px;\n          padding: 0px 15px;\n          padding: 20px 20px;\n          border-radius: 15px;\n          padding-bottom: 0px;\n          text-decoration: none;\n          background: white;\n          position: relative;\n          margin-right: 10px;\n          overflow: hidden;\n\n          .card-body {\n            a {\n              color: #000;\n              text-decoration: none;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n\n          .card-title {\n            font-weight: bold;\n          }\n\n          .customer-name {\n            font-size: 15px;\n            color: #000;\n            padding-bottom: 5px;\n            border-bottom: 1px solid #d2d2d2;\n            margin-bottom: 5px;\n          }\n        }\n\n        .btn-done {\n          background-color: #8ba6eb;\n          padding: 5px 15px;\n          border-radius: 5px;\n          margin-right: 10px;\n          color: white;\n          width: calc(50% - 10px);\n        }\n\n        .button-section {\n          width: calc(100% + 40px);\n          position: relative;\n          margin-left: -20px;\n\n          .confirm-text {\n            width: 90%;\n            margin: auto;\n          }\n\n          .btn {\n            width: 50%;\n            background-color: black;\n            padding: 5px 15px;\n            color: white;\n            border-radius: 0px;\n            text-transform: uppercase;\n\n            &.complete-btn {\n              border-right: 1px solid white;\n            }\n\n            &.assign-btn {\n            }\n\n            &:hover {\n              background-color: #9d9d9d;\n              transition: all 0.5s ease;\n            }\n          }\n\n          /* one item */\n          .btn:first-child:nth-last-child(1) {\n            /* -or- li:only-child { */\n            width: 100%;\n          }\n\n          /* two items */\n          .btn:first-child:nth-last-child(2),\n          .btn:first-child:nth-last-child(2) ~ .btn {\n            width: 50%;\n          }\n        }\n\n        .confirmationLinks {\n          // border-color: transparent;\n          // padding: 5px 15px;\n          // border-radius: 5px;\n          // margin-right: 10px;\n          // color: white;\n          // width: calc(50% - 10px);\n          // display: inline-block;\n          // text-decoration: none;\n          // &.yes {\n          //     background-color: black;\n          // }\n          // &.no {\n          //     background-color: black;\n          // }\n        }\n      }\n    }\n\n    .nav-tabs {\n      &.submenu {\n        .nav-link {\n          font-size: 17px;\n          margin-right: 10px;\n        }\n      }\n\n      border: none;\n\n      .nav-link {\n        position: relative;\n        background-color: transparent;\n        border: none;\n        padding: 0px;\n        margin-right: 30px;\n        font-size: 25px;\n        color: #9d9d9d;\n        position: relative;\n        font-weight: bold;\n\n        &.active {\n          color: black;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            background-color: #cba5ac;\n            width: 30px;\n            height: 5px;\n            top: -5px;\n            left: 0;\n            border-radius: 15px;\n          }\n\n          .activity-badge-section {\n            border: 2px solid #524c58;\n            color: #524c58;\n          }\n        }\n\n        .notification-count {\n          display: inline-block;\n          color: white;\n          width: 24px;\n          line-height: 24px;\n          font-size: 15px;\n          text-align: center;\n          border-radius: 50%;\n          background-color: #cba5ac;\n        }\n\n        .badge-section {\n          position: absolute;\n          background: transparent;\n          border: 2px solid #e3b5bb;\n          color: black;\n          font-size: 15px;\n          line-height: 12px;\n          padding: 5px 6px;\n          margin-left: 5px;\n          border-radius: 5px;\n        }\n\n        .activity-badge-section {\n          position: relative;\n          top: -10px;\n          right: 0px;\n          border: 2px solid #9d9d9d;\n          /* height: 20px; */\n          font-size: 12px;\n          line-height: 12px;\n          padding: 2px 6px;\n          color: #9d9d9d;\n          border-radius: 5px;\n        }\n      }\n    }\n\n    .accordions {\n      // margin-top: 15px;\n      .accordion {\n        overflow: auto;\n\n        // margin-top: 15px;\n        .accordion-link {\n          color: black;\n          font-size: 15px;\n\n          &:hover {\n            text-decoration: none;\n          }\n        }\n\n        .accordion-data {\n          display: none;\n\n          &:first-child {\n            margin-top: 0px;\n          }\n\n          &.show {\n            display: block;\n          }\n\n          .accordion-order-data {\n            color: black;\n            display: block;\n            margin-bottom: 20px;\n            padding: 0px 15px;\n            padding: 20px 20px;\n            border-radius: 15px;\n            padding-bottom: 0px;\n            text-decoration: none;\n            background: white;\n            position: relative;\n            margin-right: 10px;\n            overflow: hidden;\n\n            // a {\n            //     color: #000;\n            //     text-decoration: none;\n            //     font-weight: bold;\n            //     &:hover {\n            //         text-decoration: underline;\n            //     }\n            // }\n            &:hover {\n              text-decoration: none;\n            }\n\n            .card-title {\n              a {\n                color: #000;\n                text-decoration: none;\n                font-weight: bold;\n\n                &:hover {\n                  text-decoration: underline;\n                }\n              }\n            }\n\n            .order-data {\n              a {\n                color: #000;\n                text-decoration: none;\n\n                &:hover {\n                  text-decoration: underline;\n                }\n              }\n            }\n\n            .order-no {\n              font-weight: bold;\n              display: block;\n              border-bottom: none;\n              margin-bottom: 0;\n              padding-bottom: 0;\n            }\n\n            .order-date {\n              position: absolute;\n              background-color: #ecedf2;\n              font-size: 13px;\n              right: 0px;\n              top: 0px;\n              padding: 3px 10px;\n            }\n\n            .order-data {\n              display: block;\n              line-height: 20px;\n              margin-bottom: 10px;\n\n              &.customer-name {\n                padding-bottom: 5px;\n                border-bottom: 1px solid #d2d2d2;\n              }\n            }\n\n            .order-time {\n              color: #d2d2d2;\n              text-align: right;\n              margin-bottom: 0;\n              font-size: 13px;\n            }\n\n            .button-section {\n              width: calc(100% + 40px);\n              position: relative;\n              margin-left: -20px;\n\n              .btn {\n                width: 50%;\n                background-color: black;\n                padding: 5px 15px;\n                color: white;\n                border-radius: 0px;\n                text-transform: uppercase;\n\n                &.complete-btn {\n                  border-right: 1px solid white;\n                }\n\n                &.assign-btn {\n                }\n\n                &:hover {\n                  background-color: #9d9d9d;\n                  transition: all 0.5s ease;\n                }\n\n                .border-right {\n                  border-right: 1px solid white;\n                }\n              }\n\n              /* one item */\n              .btn:first-child:nth-last-child(1) {\n                /* -or- li:only-child { */\n                width: 100%;\n              }\n\n              /* two items */\n              .btn:first-child:nth-last-child(2),\n              .btn:first-child:nth-last-child(2) ~ .btn {\n                width: 50%;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.except-left-section {\n  width: calc(100% - 120px);\n  min-height: 100%;\n  height: 100vh;\n  overflow: auto;\n  padding: 15px;\n  background: #f3f6fd;\n\n  .back-to-table {\n    a {\n      color: black;\n      font-size: 15px;\n\n      .back-icon {\n        background-color: #8ba6eb;\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        display: inline-block;\n        line-height: 34px;\n        text-align: center;\n        color: white;\n        margin-right: 10px;\n      }\n\n      &:hover {\n        text-decoration: none;\n      }\n\n      .add-icon {\n        float: right;\n        background-color: #8ba6eb;\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        display: inline-block;\n        line-height: 34px;\n        text-align: center;\n        color: white;\n        margin-right: 10px;\n      }\n    }\n  }\n\n  .white-box {\n    background-color: white;\n    padding: 15px;\n    margin-bottom: 15px;\n  }\n\n  .order_detail {\n    .data-card {\n      background-color: white;\n      border: 1px solid #f8f8f8;\n      border-bottom-right-radius: 15px;\n      border-top-right-radius: 15px;\n      margin-bottom: 15px;\n\n      .information-heading {\n        border-top-right-radius: 15px;\n        color: white;\n        text-align: left;\n        padding: 7px 15px;\n        font-size: 25px;\n        line-height: 25px;\n\n        &.customer-information {\n          background-color: #74cdd2;\n        }\n\n        &.payment-information {\n          background-color: #f1764a;\n        }\n\n        &.product-information {\n          background-color: #f2d39a;\n        }\n\n        &.manufacturing-information {\n          background-color: #acd6ca;\n        }\n\n        &.discussion-information {\n          background-color: #ace9fb;\n        }\n\n        &.history-information {\n          background-color: #7c759f;\n        }\n      }\n\n      .information-details {\n        .details {\n          padding: 15px !important;\n\n          .shipping_informaiton {\n            margin-bottom: 15px;\n\n            h3 {\n              font-weight: bold;\n            }\n          }\n\n          .billing_informaiton {\n            margin-bottom: 15px;\n\n            h3 {\n              font-weight: bold;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.Completed {\n  color: green;\n}\n\n.Assigned {\n  color: orange;\n}\n\n.due-date-warning {\n  color: red;\n}\n\n.confirmationLinks {\n  cursor: pointer;\n  color: blue;\n  text-decoration: underline;\n}\n\n.add-task-button {\n  cursor: pointer;\n}\n\na.add_link {\n  cursor: pointer;\n}\n\n.form-control.box-bg {\n  height: 32px;\n}\n\n.content-table-stock-number {\n  max-height: 40vh;\n  overflow-y: scroll;\n}\n\n.btn-novitadimonds {\n  height: 30px !important;\n  border-radius: 6px !important;\n  text-align: center !important;\n  background-color: #dfa4a3 !important;\n  font-size: 15px !important;\n  font-family: \"mreaves-regular\";\n  border-color: #dfa4a3 !important;\n  color: #fff !important;\n  min-width: max-content;\n  padding: 0px 5px !important;\n}\n\n.btn-novitadimonds:hover {\n  color: #fff !important;\n  background-color: #dfa4a3 !important;\n  border-color: #dfa4a3 !important;\n}\n\n.hide {\n  display: none;\n}\n\n.form-select.is-valid,\n.was-validated .form-select:valid {\n  border-color: #e3b5bb !important;\n}\n\n.form-select:focus {\n  box-shadow: none !important;\n}\n\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: #e3b5bb !important;\n}\n\n.form-check-input.is-valid ~ .form-check-label,\n.was-validated .form-check-input:valid ~ .form-check-label {\n  color: #000 !important;\n}\n\n.form-check-input.is-valid:checked,\n.was-validated .form-check-input:valid:checked {\n  background-color: #e3b5bb !important;\n}\n\n.form-check-input.is-valid,\n.was-validated .form-check-input:valid {\n  border-color: #e3b5bb !important;\n}\n\n.has-success .fv-plugins-icon {\n  color: red;\n}\n\n.icon-btn-novitadiamond {\n  height: 20px;\n  background: #e3b5bb;\n  border-radius: 50%;\n  padding: 6px;\n  color: white;\n}\n\n.grid-padding-0 {\n  display: grid;\n  padding: 0;\n}\n\n.line-height-initial {\n  line-height: initial;\n}\n\n.position-sticky-bottom {\n  position: sticky;\n  bottom: 10px;\n}\n\n.float-right {\n  float: right;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.not-margin {\n  margin: 0px !important;\n}\n\n.input-group-pink {\n  .form-control {\n    border-color: #e3b5bb !important;\n  }\n\n  .input-group-text {\n    color: white;\n    background: #e3b5bb;\n    border-color: #e3b5bb;\n  }\n}\n\n.card-sale-commissions {\n  overflow-y: scroll;\n  max-height: 84vh !important;\n\n  .table-hover > tbody > tr > td.error {\n    background: #d66;\n    color: white !important;\n  }\n\n  .table-hover > tbody > tr > td.success {\n    background: #35b97d;\n    color: white !important;\n  }\n}\n\n.btn-icon-pink {\n  height: 30px !important;\n  width: 30px !important;\n  border-radius: 50% !important;\n  font-size: 16px !important;\n  line-height: 15px !important;\n  border: 1px solid #e3b5bb !important;\n  background: #e3b5bb !important;\n  margin-left: 15px !important;\n  text-align: center !important;\n  color: white !important;\n  padding: 0px !important;\n  display: inline-block !important;\n}\n\n.order-number-small {\n  font-size: 14px !important;\n}\n\n.disabled-btn {\n  cursor: no-drop !important;\n  opacity: 0.5 !important;\n}\n\n.hidden-elements {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.qcc-title-inprocess {\n  padding: 0px 5px;\n  border-radius: 5px;\n}\n\n.tooltip-extra-info {\n  color: #c9c9c9;\n  font-size: 12px;\n  text-decoration: underline;\n}\n\n.table-container {\n  width: 100%;\n  max-height: 65vh;\n  overflow-y: auto;\n  overflow-x: auto;\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n\n  th,\n  td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n  }\n\n  thead {\n    background-color: #000;\n    color: #fff;\n    position: sticky;\n    top: 0;\n  }\n}\n\n.react-datepicker-popper {\n  z-index: 999999;\n}\n\n.loading-process {\n  #LoadingLayer_component {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
